export default __webpack_public_path__ + "static/media/img3.8f0578e6.png";